import { Flex, Heading } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Header() {
  return (
    <Flex justify="space-between" align="center">
      <Heading as="h4" size="md" mb={8}>
        <FontAwesomeIcon icon={['fal', 'building']} /> Suites
      </Heading>
    </Flex>
  );
}

export default Header;
